import axios from 'axios';

const apiUrl = '/api/DataBi/ai/vertex/textPrompt';

export function getPromptText(data) {
  return axios.post(apiUrl, data);
}
